// Assets live in `public/` and are served from the site root — reference
// them by their served URL, not via `import` (Vite disallows importing
// from the public directory).
const eduLogo = "/assets/images/edu_logo.webp";
const eduLogoIcon = "/assets/images/edu.webp";
const leadsIllustration = "/assets/images/leads.webp";
const school = "/assets/images/school.webp";
const loginIllustration = "/svg/login.svg";
const dashboardWelcome = "/assets/superadmin.png";
const orghouse = "/assets/images/orghouse.png";

export const IMAGES = {
  eduLogo,
  eduLogoIcon,
  leadsIllustration,
  school,
  dashboardWelcome,
  orghouse,
};

export const SVGS = {
  loginIllustration,
};
